import { Component, Input } from '@angular/core';

import { Data2Service } from '../../../common/data2.service';

import { FiltersComponent } from '../../../common/filters.component';

@Component({
	selector: 'app-drivers-list-filters',
	templateUrl: './drivers-list-filters.component.html',
	styleUrls: ['./drivers-list-filters.component.css'],
})
export class DriversListFiltersComponent extends FiltersComponent {
	@Input() yesno: Array<any>;
	@Input() statuses: Array<any>;
	@Input() driverKinds: Array<any>;
	filters = {
		drivers: null,
		statuses: null,
		driverKinds: null,
		vaccinations: null,
		trailer: null,
	};

	filtersDefault() {
		this.filtersClear();
		this.filters.statuses = ['REGULAR', 'JUMPER', 'MAYBE'];
	}
}
